import { type JSX } from 'react';

import { type IconComponent } from '@/components/icons';
import { type OpsSem, semDot } from '@/components/ops/sem';
import { cn } from '@/lib/utils';

// Legend — a colored dot + label for a table footer's semaphore key.
export function Legend({ sem, label }: { sem: OpsSem; label: string }): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={cn('inline-block w-2.5 h-2.5 rounded-full', semDot[sem])} aria-hidden />
      {label}
    </span>
  );
}

// ActionLegend names one of the actions column's icons, with the action's full
// help text as the tooltip — the explanation the text buttons used to carry.
export function ActionLegend({
  icon: IconComp,
  label,
  help,
}: {
  icon: IconComponent;
  label: string;
  help: string;
}): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1 cursor-help" title={help}>
      <IconComp width={13} height={13} aria-hidden />
      {label}
    </span>
  );
}
